/**
 * TokenPush
 * @author aldo-maciel
 */
import { ID, Resource, ResponseSerialize } from 'simpli-web-sdk'
import Motorista from '@/model/resource/Motorista'

export default class TokenPush extends Resource {

  get $id() {
    return this.idTokenPushPk
  }

  set $id(val: ID) {
    this.idTokenPushPk = val
  }

  get idMotoristaFk() {
    return this.motorista!.idMotoristaPk
  }

  set idMotoristaFk(value: ID) {
    this.motorista!.idMotoristaPk = value
  }

  readonly $name: string = 'TokenPush'
  readonly $endpoint: string = ''

  idTokenPushPk: ID = 0
  modeloAparelho: string | null = null
  marcaAparelho: string | null = null
  token: string | null = null

  @ResponseSerialize(Motorista)
  motorista: Motorista | null = null
}
